import { createStyles } from '@material-ui/core'

const styles = () =>
  createStyles({
    logoBox: {
      width: '130px',
    },
    logo: {
      // height: '35px',
      width:'100%'
    },
  })

export default styles
